export default __webpack_public_path__ + "static/media/7.ffe8dd5e.png";